import { API_CONFIG } from "../../config/api";
import { getApiClientOptions } from "../client";
import { graphqlRequest } from "../graphqlClient";

export interface ColumnInput {
  name: string;
  displayName?: string;
}

export interface CreateExportJobInput {
  format: string;
  form: string;
  columns: ColumnInput[];
  filter?: string | null;
}

export interface CreateExportJobResult {
  id: string;
}

export async function createExportJob(
  input: CreateExportJobInput,
): Promise<CreateExportJobResult> {
  const mutation = `
    mutation CreateExportJob($input: CreateExportJobInput!) {
      exports {
        createExportJob(input: $input) {
          id
        }
      }
    }
  `;
  const data = await graphqlRequest<{
    exports: { createExportJob: CreateExportJobResult };
  }>(mutation, { input });
  return data.exports.createExportJob;
}

export async function pollExportDownload(
  exportId: string,
): Promise<
  | { status: "ready"; blob: Blob }
  | { status: "pending" }
  | { status: "failed"; message: string }
> {
  const url = `${API_CONFIG.baseUrl}/api/v1/exports/${exportId}`;
  const options = getApiClientOptions();

  const headers: Record<string, string> = {};

  if (options.instanceId) {
    headers["x-instance-id"] = options.instanceId;
  }

  if (options.getAccessToken) {
    try {
      const token = await options.getAccessToken();
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // ignore
    }
  }

  const response = await fetch(url, { method: "GET", headers });

  if (response.status === 200) {
    const blob = await response.blob();
    return { status: "ready", blob };
  }
  if (response.status === 204 || response.status === 404) {
    return { status: "pending" };
  }
  return { status: "failed", message: response.statusText };
}
